import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, OnInit, Output, signal } from '@angular/core';
import { SelectClaimService } from './service/select-claim.service';
import { FormsModule } from '@angular/forms';
import { SelectClaimData, SelectClaimResponse } from './interfaces/select-claim.interface';

@Component({
  selector: 'select-claim',
  imports: [CommonModule, FormsModule],
  templateUrl: './select-claim.component.html',
  styleUrl: './select-claim.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectClaimComponent implements OnInit {

  selectClaimService = inject(SelectClaimService);

  selectedClaim = signal<string>('');

  listClaims = signal<SelectClaimData[]>([]);
 @Output() selectedClaimChange = new EventEmitter<string>();

  ngOnInit(): void {
    this.selectClaimService.loadListClaims().pipe().subscribe({
      next: (response: SelectClaimResponse) => {
        this.listClaims.set(response.data);
      },
      error: (error) => {
        this.listClaims.set([]);
      }
    })
  }


  onSelectClaim(claim: string): void {
    this.selectedClaim.set(claim);
    this.selectedClaimChange.emit(claim);
  }
}
